import { Box, Divider, Drawer, DrawerBody, DrawerCloseButton, Button, DrawerContent, DrawerHeader, Menu, MenuButton, MenuList, MenuItemOption, MenuOptionGroup, DrawerOverlay, Flex, Grid, GridItem, Heading, Select, Text, useDisclosure, Input } from '@chakra-ui/react'
import MyDiv from './dashboard.style'
import { AnnouncementCard, AnnouncementForm, AttendanceCard, BirthdayCard, CheckInOutCard, EmployeeChartCard, HolidayCard, IncrementMarquee, PayrollCard, PaySlipCard, QuickCard, WorkAnniversaryCard } from './components'
import { useAuth } from '../../hooks/useAuth'
import { useEffect, useState } from 'react'
import { CustomToast } from '../../components'
import { baseUrl, ideaUrl, useFetch } from '../../hooks/useFetch'
import { MultiSelectMenu } from '../../components/MultiSelectMenu/MultiSelectMenu'
import ResignationNotification from './components/ResignationNotification'
import OnlineEmployee from './components/OnlineEmployee'
import { ChevronDownIcon } from '@chakra-ui/icons'
import IdeaPublishedMarquee from './components/IdeaPublishedMarquee/IdeaPublishedMarquee'
import MemorialSupportCard from './components/MemorialSupportCard/MemorialSupportCard'
import AssetSummaryCard from './components/AssetSummaryCard/AssetSummaryCard'

const Dashboard = () => {
  const { hasPermission, loginObj } = useAuth();
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [employeeName, setEmployeeName] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [reload, setReload] = useState(false);
  // const [selectedBranch, setSelectedBranch] = useState<number>(0);
  const [employeeBranch, setEmployeeBranch] = useState<any[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<number[]>([]);
  const [incrementNotification, setIncrementNotification] = useState<any | null>(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [publishedIdeaNotification, setPublishedIdeaNotification] = useState<any | null>(null);

  const loadPublishedIdeaNotification = async () => {
    const response = await fetchApi("IdeaCategory/published-notification", "GET");
    if (response) setPublishedIdeaNotification(response);
  };

  useEffect(() => { loadPublishedIdeaNotification(); }, []);


  const filteredBranches = employeeBranch.filter((branch) =>
    branch.branchName.toLowerCase().includes(searchTerm.toLowerCase())
  );


  useEffect(() => {
    const loginData = sessionStorage.getItem('loginData');
    if (loginData) {
      const parsedData = JSON.parse(loginData);
      setEmployeeName(parsedData.employeeName);
    }
    laodEmployeeAssignedBranch();
  }, []);


  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Morning';
    else if (hour < 17) return 'Afternoon';
    else return 'Evening';
  };

  const laodEmployeeAssignedBranch = async () => {
    const response = await fetchApi("Dashboard/assignedBranch", "GET", "", "", "");
    if (response) {
      setEmployeeBranch(response);
    }
  }


  const loadIncrementNotification = async () => {
    const response = await fetchApi("Increment/incrementNotification", "GET")
    if (response) setIncrementNotification(response);
  }

  useEffect(() => {
    loadIncrementNotification()
  }, [])

  const handleBranchChange = (values: string[]) => {
    const numericValues = values.map(Number);
    if (numericValues.includes(0) && !selectedBranch.includes(0)) {
      setSelectedBranch([0, ...employeeBranch.map(x => x.branchId)]);
      return;
    }
    if (!numericValues.includes(0) && selectedBranch.includes(0)) {
      setSelectedBranch([]);
      return;
    }
    setSelectedBranch(numericValues);
  };

  const openIdeaManagement = async () => {
    if (loginObj?.token != null) {
      const response = await fetch(`${baseUrl}sso/generate-token`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loginObj.token}`
        }
      });

      const result = await response.json();

      if (result.success) {
        window.open(ideaUrl + result.url, "_blank");
      }
    }
  };

  return (
    <MyDiv>
      <Box className="page_wrapper">
        <Flex className="page_heading flex_header" justifyContent="space-between">
          <Heading as="h1" className="font-poppins font_dark text_semibold text_3xl">Dashboard</Heading>
          <Flex alignItems="center" gap={4}>
            {hasPermission("Dashboard", "BranchDropdown") && (
              <Menu closeOnSelect={false} onClose={() => setSearchTerm('')}>
                <MenuButton as={Button} rightIcon={<ChevronDownIcon />} width="200px" variant="outline" fontWeight="normal">
                  {selectedBranch.length === 0 ? "Select Branch" : selectedBranch.includes(0) ? "All Branches"
                    : `${selectedBranch.length} Branch${selectedBranch.length > 1 ? 'es' : ''} selected`}
                </MenuButton>
                <MenuList minWidth="220px" maxHeight="300px" overflowY="auto" zIndex={10}>
                  <Box px={3} pb={2}>
                    <Input size="sm" placeholder="Search branch..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} onKeyDown={(e) => e.stopPropagation()} />
                  </Box>
                  <Divider />
                  <MenuOptionGroup type="checkbox" value={selectedBranch.map(String)} onChange={(values) => handleBranchChange(values as string[])}
                  >
                    <MenuItemOption value="0">Select All</MenuItemOption>
                    <Divider />
                    {filteredBranches.length > 0 ? (
                      filteredBranches.map((branch) => (
                        <MenuItemOption key={branch.branchId} value={String(branch.branchId)}>  {branch.branchName} </MenuItemOption>
                      ))
                    ) : (
                      <Text px={3} py={2} fontSize="sm" color="gray.500">No branch found</Text>
                    )}
                  </MenuOptionGroup>
                </MenuList>
              </Menu>
            )}
            {hasPermission("Dashboard", "OnlineEmployee") && (
              <Box >
                <OnlineEmployee />
              </Box>
            )}
          </Flex>
        </Flex>
        {incrementNotification &&
          incrementNotification.employeeName &&
          incrementNotification.incrementPercent !== "0.00%" && (
            <Grid className="grid_container grid_gap_sm" >
              <GridItem colSpan={12} mt={2}>
                <IncrementMarquee incrementNotification={incrementNotification} />
              </GridItem>
            </Grid>
          )}

        {publishedIdeaNotification && publishedIdeaNotification.ideaTitle && (
          <Grid className="grid_container grid_gap_sm">
            <GridItem colSpan={12} mt={2}>
              <IdeaPublishedMarquee notification={publishedIdeaNotification} onClick={openIdeaManagement} />
            </GridItem>
          </Grid>
        )}

        <Grid className="grid_container grid_gap_sm" style={{ gap: '2' }}>
          <GridItem colSpan={9} mt={2}>
            <Flex justify="space-between">
              <Text className="font-poppins common_color text_medium text_xl" mt={2}>
                {`Good ${getGreeting()},  ${employeeName || 'User'}`}
              </Text>

            </Flex>
          </GridItem>
        </Grid>

        {/* {hasPermission('Dashboard', 'ResignationNotification') && (
          <Grid className="grid_container grid_gap_sm">
            <GridItem colSpan={9} mt={2}>
              <ResignationNotification />
            </GridItem>
          </Grid>
        )} */}


        {/* <Grid className="grid_container grid_gap_sm">
          <GridItem colSpan={12} mt={2}>
            <MemorialSupportCard />
          </GridItem>
        </Grid> */}

        <Grid className="grid_container grid_gap_sm">
          <GridItem colSpan={9} mt={2}>
            <ResignationNotification />
          </GridItem>
        </Grid>

        {(hasPermission('Dashboard', 'AllAssetSummary') || hasPermission('Dashboard', 'BranchWiseAssetSummary')) && (
          <Grid className="grid_container grid_gap_sm">
            <GridItem colSpan={9} mt={2}>
              <AssetSummaryCard />
            </GridItem>
          </Grid>
        )}


        {hasPermission('Dashboard', 'CheckInOutCard') ? (
          <>
            <Grid className="grid_container grid_gap_sm" style={{ gap: '2' }}>
              <GridItem colSpan={9} mt={2}>
                <CheckInOutCard />
                <Box mt={4}>
                  <AnnouncementCard reload={reload} branch={selectedBranch} />
                </Box>
                <Grid className="grid_container grid_gap_sm">
                  <GridItem colSpan={5} mt={4}>
                    <BirthdayCard />
                  </GridItem>
                  <GridItem colSpan={5} mt={4}>
                    <HolidayCard />
                  </GridItem>
                  <GridItem colSpan={5} mt={4}>
                    <WorkAnniversaryCard />
                  </GridItem>
                </Grid>
              </GridItem>
              <GridItem colSpan={3}>
                {hasPermission('Dashboard', 'QuickCard') && <QuickCard onAnnouncementClick={onOpen} />}
                <Box mt={4}>
                  {hasPermission('Dashboard', 'PaySlipCard') && <PaySlipCard />}
                </Box>
              </GridItem>
            </Grid>
          </>
        ) : (
          <>
            <Grid className="grid_container grid_gap_sm">
              <GridItem colSpan={9}>
                <Grid className="grid_container grid_gap_sm" mt={3}>
                  {hasPermission('Dashboard', 'Attendance') && (
                    <GridItem colSpan={6}>
                      <AttendanceCard branch={selectedBranch} />
                    </GridItem>
                  )}
                  {hasPermission('Dashboard', 'PayrollProcess') && (
                    <GridItem colSpan={6}>
                      <PayrollCard branch={selectedBranch} />
                    </GridItem>
                  )}
                </Grid>
              </GridItem>
              <GridItem colSpan={3} mt={4}>
                <QuickCard onAnnouncementClick={onOpen} />
              </GridItem>
            </Grid>

            <Grid className="grid_container grid_gap_sm" mt={2}>
              <GridItem colSpan={hasPermission('Dashboard', 'EmployeeChartCard') ? 9 : 12}>
                <AnnouncementCard reload={reload} branch={selectedBranch} />
              </GridItem>
              {hasPermission('Dashboard', 'EmployeeChartCard') && (
                <GridItem colSpan={3}>
                  <EmployeeChartCard branch={selectedBranch} />
                </GridItem>
              )}
            </Grid>

            <Grid className="grid_container grid_gap_sm" mt={4}>
              {hasPermission('Dashboard', 'PaySlipCard') && (
                <GridItem colSpan={3}>
                  <PaySlipCard />
                </GridItem>
              )}
              <GridItem colSpan={hasPermission('Dashboard', 'PaySlipCard') ? 4 : 4}>
                <BirthdayCard branch={selectedBranch} />
              </GridItem>
              <GridItem colSpan={hasPermission('Dashboard', 'PaySlipCard') ? 4 : 4}>
                <HolidayCard />
              </GridItem>
              <GridItem colSpan={hasPermission('Dashboard', 'PaySlipCard') ? 4 : 4}>
                <WorkAnniversaryCard branch={selectedBranch} />
              </GridItem>
            </Grid>
          </>
        )}
      </Box>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="lg">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader>Add an Announcement</DrawerHeader>
          <DrawerCloseButton />
          <Divider />
          <DrawerBody>
            <AnnouncementForm onClose={onClose} reload={reload} setReload={setReload} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </MyDiv>
  )
}

export default Dashboard